import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import getAvailableFiltersForExclusionRuleWorksheet from './getAvailableFiltersForExclusionRuleWorksheet';

import { RootState } from '../../../stores/types';

export default createSelector<
RootState, io.flow.v0.unions.AvailableFilter[]
| undefined, io.flow.v0.models.AvailableFilterStructured[]
| Array<any>
>(
  getAvailableFiltersForExclusionRuleWorksheet,
  (availableFilters) => filter(availableFilters, { discriminator: 'structured' }),
);
